export const testimonialsData = [
  {
    name: 'Sonia da Cunha',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-sonia.ef4c7bfc.png',
    videoId: 'rOPJEDdojDY'
  },
  {
    name: 'Ednalva Oliveira',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-ednalva.d270bda6.png',
    videoId: 'uSY9ep-lWoE'
  },
  {
    name: 'Leticia do Nascimento',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-leticia.27557296.png',
    videoId: 'eDaoA2bmQ24'
  },
  {
    name: 'Maria José da Silva',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-maria.9b76f421.png',
    videoId: 'oB9tNHt2e0E'
  },
  {
    name: 'Flavio Porto Alegre',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-flavio.8c5d0b40.png',
    videoId: 'YLskc2Asf3A'
  },
  {
    name: 'Pamela Rodrigo',
    thumbnail: 'https://www.cartaodetodos.com.br/_next/static/media/testimonial-pamela.a51681bf.png',
    videoId: '1E5-SXGyZFc'
  }
]
